module.exports = "images/3ans.2c6350b8.png";